// Knowledge Bases Store Module
import { createBaseModule } from './base'
import { knowledgeBasesApi } from '@/services/api'

// Custom state for knowledge bases
const customState = {
  documents: []
}

// Custom actions for knowledge bases
const customActions = {
  // Get documents for a knowledge base
  async getDocuments({ commit }, kbId) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const documents = await knowledgeBasesApi.getDocuments(kbId)
      commit('SET_DOCUMENTS', documents)
      
      return documents
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch documents')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Upload document to knowledge base
  async uploadDocument({ commit, dispatch }, { kbId, formData }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const document = await knowledgeBasesApi.uploadDocument(kbId, formData)
      
      dispatch('showSuccess', 'Document uploaded successfully', { root: true })
      
      return document
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to upload document')
      dispatch('handleError', error, { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Delete a document from a knowledge base
  async deleteDocument({ commit }, { knowledgeBaseId, documentId }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')

      await knowledgeBasesApi.deleteDocument(knowledgeBaseId, documentId)

      return true
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to delete document')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Search knowledge base
  async search({ commit }, { kbId, query, limit = 10 }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const results = await knowledgeBasesApi.searchKnowledgeBase(kbId, query, limit)
      
      return results
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to search knowledge base')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Archive a knowledge base
  async archive({ commit, dispatch }, kbId) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')

      const res = await knowledgeBasesApi.archive(kbId)

      dispatch('showSuccess', 'Knowledge base archived successfully', { root: true })
      return res
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to archive knowledge base')
      dispatch('handleError', error, { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

// Custom mutations for knowledge bases
const customMutations = {
  SET_DOCUMENTS(state, documents) {
    state.documents = Array.isArray(documents) ? documents : []
  }
}

// Create and export the knowledge bases module
export default createBaseModule('knowledge base', knowledgeBasesApi, {
  customState,
  customActions,
  customMutations
})
